import api from './Api';
import { AxiosPromise } from 'axios';
import { LoginData } from '@/store/types';

class Authentication {
    public start(): AxiosPromise {
        return api.post('authentication/index/start');
    }

    public login(params?: LoginData): AxiosPromise {
        return api.post('authentication/index/login', params);
    }

    public authdata(): AxiosPromise {
        return api.post('authentication/index/authdata');
    }

    public logout(): AxiosPromise {
        return api.post('authentication/index/logout');
    }

    public loginurl(): AxiosPromise {
        return api.post('authentication/index/loginurl');
    }
}

const authService = new Authentication();
export default authService;
